import * as React from "react";

const Unassigned: React.SFC<{}> = () => {
    return (
        <div>
            Unassigned!
        </div>
    );
}

export default Unassigned;